import { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/css/customersearch.css"


function SelectCustomer({
  customers = [],
  selectedCustomer,
  onChange,
  onSearch,
}) {
  const [search, setSearch] = useState("");
  const [activeIndex, setActiveIndex] = useState(-1);

  const listRef = useRef(null);

  // API Search
  useEffect(() => {
    const timer = setTimeout(() => {
      if (search.trim() !== "") {
        onSearch?.(search);
      }
      setActiveIndex(-1);
    }, 300);

    return () => clearTimeout(timer);
  }, [search, onSearch]);

  // Scroll active item
  useEffect(() => {
    if (
      activeIndex >= 0 &&
      listRef.current?.children[activeIndex]
    ) {
      listRef.current.children[activeIndex].scrollIntoView({
        block: "nearest",
      });
    }
  }, [activeIndex]);

  // Show only customers whose name starts with search
 const filteredCustomers =
  search.trim() === ""
    ? []
    : customers.filter((customer) =>
        customer.accountName
          ?.toLowerCase()
          .startsWith(search.toLowerCase())
      );

  // Highlight only first letter
const highlightText = (text = "", keyword = "") => {
  if (!keyword) return text;

  if (!text.toLowerCase().startsWith(keyword.toLowerCase())) {
    return text;
  }

  return (
    <>
      <span
        style={{
          color: "#000",
          fontWeight: "700",
        }}
      >
        {text.substring(0, keyword.length)}
      </span>
      {text.substring(keyword.length)}
    </>
  );
};

  // Keyboard Navigation
  const handleKeyDown = (e) => {
    if (!filteredCustomers.length) return;

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setActiveIndex((prev) =>
          prev < filteredCustomers.length - 1 ? prev + 1 : 0
        );
        break;

      case "ArrowUp":
        e.preventDefault();
        setActiveIndex((prev) =>
          prev > 0 ? prev - 1 : filteredCustomers.length - 1
        );
        break;

      case "Enter":
        e.preventDefault();
        if (activeIndex >= 0) {
          onChange(filteredCustomers[activeIndex]);
        }
        break;

      default:
        break;
    }
  };

  return (
    <div className="position-relative rounded shadow  customersearchdata">

      <input
        type="text"
        className="form-control"
        placeholder="Search Customer..."
        autoFocus
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={handleKeyDown}
        style={{  borderRadius:"3px"}}
      />

   {search.trim() !== "" && (
  <div
    ref={listRef}
    className="list-group customer-search-item "
    >
    {filteredCustomers.length > 0 ? (
      filteredCustomers.map((customer, index) => (
 <div
  key={customer.id}
  className={`customer-search-row ${
    activeIndex === index ? "active" : ""
  }`}
  onMouseEnter={() => setActiveIndex(index)}
  onClick={() => onChange(customer)}
>
  <div className="fw-semibold">
    {highlightText(customer.accountName, search)}
  </div>

  {customer.customerCode && (
    <small>{customer.customerCode}</small>
  )}
</div>
))
    ) : (
      <div className="text-center p-3 text-danger">
        No customer found
      </div>
    )}
  </div>
)}
    </div>
  );
}

export default SelectCustomer;